// import MessengerCustomerChat from "react-messenger-customer-chat";
import Copyright from "src/components/Copyright";
import MenuFooter from "src/components/MenuFooter";
import { sFooter } from "src/styles/sFooter.module.scss";

function Footer() {
  return (
    <div className={sFooter}>
      <MenuFooter />
      <Copyright />
      {/*<MessengerCustomerChat
        pageId={constants.Social.fbPageId}
        appId={constants.Social.fbAppId}
        htmlRef={`chatWidgetRef`}
        minimized={true}
        language={`cs_CZ`}
        themeColor={constants.Theme.primary}
        greetingDialogDisplay={`fade`}
        loggedInGreeting={`Ahoj, jsme tady pro tebe, napiš co tě těší nebo trápí. Určitě najdeme společnou řeč.`}
        loggedOutGreeting={`Měj pěkný den. Tým Vivido`}
      />*/}
    </div>
  );
}

export default Footer;
